import { useEffect, useRef } from 'react'

import { isSpokenAriaMode, showsAriaSubtitles, type AriaInteractionMode } from '../../../../pure-js/types/AppAssistant'

/** True only for the spoken-without-captions → spoken-with-captions transition. */
export const useRevealExistingAriaSubtitle = (mode: AriaInteractionMode): boolean => {
  const previousModeRef = useRef(mode)
  const previousMode = previousModeRef.current
  const shouldReveal = isSpokenAriaMode(previousMode) && !showsAriaSubtitles(previousMode) && showsAriaSubtitles(mode)

  useEffect(() => {
    previousModeRef.current = mode
  }, [mode])

  return shouldReveal
}
